import { mapFromSection, devLog } from './utilities';

function Store(data = {}) {
    const self = this;
    const { structure, values } = data;

    this.structure = structure;
    this.values = values;
    this.required = [];

    this.getMap();

    // Identify all required fields for this questionnaire section
    Object.keys(this.map).forEach(thisKey => {
        const thisItem = self.map[thisKey];
        const { props, dependencies } = thisItem;

        if (props && props.required) {
            self.required.push(thisItem.name);
        }
    });
}

Store.prototype.getMap = function () {
    if (!this.map) {
        this.map = mapFromSection(this.structure);
    }

    return this.map;
}

Store.prototype.getRequired = function () {
    return this.required;
}

Store.prototype.getUnfinishedQuestions = function (data) {
    const unfinished = [];
    const map = this.getMap();
    const { values } = data;

    Object.keys(map).forEach((thisKey) => {
        const thisItem = map[thisKey];
        const { name, visible, props = {} } = thisItem;
        const { optional, hidden } = props;

        const isRequired = name && visible && !optional && !hidden;

        if (!isRequired) {
            return;
        }

        const val = values[name];
        const { type } = thisItem;

        switch (type) {
            case 'data-table': 
            case 'expandable-table': {
                if (!val || val.length === 0) {
                    unfinished.push(thisItem);
                }
                break;
            }
            default: {
                if (val === undefined || val === '') {
                    unfinished.push(thisItem);
                }
            }
        }
    });

    devLog('Unfinished Questions:', unfinished);

    return unfinished;
}

export default Store;


// WEBPACK FOOTER //
// ./src/components/store.js